import { render, staticRenderFns } from "./indexBi.vue?vue&type=template&id=57977fd8&scoped=true"
import script from "./indexBi.vue?vue&type=script&lang=js"
export * from "./indexBi.vue?vue&type=script&lang=js"
import style0 from "./indexBi.vue?vue&type=style&index=0&id=57977fd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57977fd8",
  null
  
)

export default component.exports